<template>
  <div>
    <div v-if="uploading" v-label-key="'FILE_UPLOADING'">
      Uploading...
    </div>
    <div>
      <b-button variant="outline-primary" @click="select()">
        <span v-if="value" v-label-key="'CHANGE'">Change</span>
        <span v-else v-label-key="'SELECT'">Select</span>
      </b-button>
      <b-button v-if="value" variant="outline-danger" @click="remove">
        <span v-label-key="'REMOVE'">Remove</span>
      </b-button>
    </div>
    <input class="file-input__input" ref="fileInput" type="file" />
    <img
      v-if="displayValue && accept === 'image/*'"
      :src="'https://cdn.gokaizen.com/' + displayValue"
      @click="select()"
    />
    <a v-else-if="displayValue" target="_blank"
      >{{ `https://cdn.gokaizen.com/${displayValue}` }}
    </a>
  </div>
</template>

<script>
import $api from '@/services/api';

export default {
  props: {
    accept: {
      type: String,
      default: 'file',
    },
    value: {
      type: String,
      default: '',
    },
    folder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      uploading: false,
      displayValue: this.value,
    };
  },

  mounted() {
    const { fileInput } = this.$refs;

    // eslint-disable-next-line consistent-return
    fileInput.addEventListener('change', () => {
      if (!this.folder) {
        return false;
      }

      if (fileInput.files.length > 0) {
        const file = fileInput.files[0];

        $api
          .post('/v1/common/cdnitem', {
            folder: this.folder,
            type: file.type,
          })
          .then((uploadInfo) => {
            this.uploading = true;
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', uploadInfo.url);
            xhr.onreadystatechange = () => {
              if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                  this.displayValue = uploadInfo.id;
                  this.uploading = false;
                  this.$emit('input', uploadInfo.id);
                }
              }
            };
            xhr.send(file);
          });
      }
    });
  },

  methods: {
    select() {
      this.$refs.fileInput.click();
    },
    remove() {
      this.displayValue = null;
      this.uploading = false;
      this.$emit('input', null);
    },
  },
};
</script>

<style scoped>
img {
  max-width: 300px;
}

.file-input__input {
  display: none;
}

button {
  width: 100%;
  margin-bottom: 10px;
}
</style>
